import FlashMessage from './flash-message';

// BE alerts handler
function initializeAlerts() {
    if (!euPortalConfig.notifications) {
        return;
    }
    const flashMessageInstance = new FlashMessage('alert-message-container');
    Object.keys(euPortalConfig.notifications).forEach(function (type) {
        //symfony, skipping. todo: remove from backend
        if (type === '_flash') {
            return;
        }
        euPortalConfig.notifications[type].map(function (message) {
            flashMessageInstance.add(type, message);
        });
    });
}

export default initializeAlerts;
